<template>

    <div class="form-inline pb-2">
        <div class="form-group">
            <label class="form-label mr-2"
                   :for="'tasks'">
                Mark As
            </label>
            <b-form-select v-model="selectedTask" :options="tasks" size="sm" class="mr-2">
                <template slot="first">
                    <option :value="null" disabled>-- Please select an option --</option>
                </template>
            </b-form-select>
        </div>
        <button type="button"
                class="btn btn-sm btn-primary"
                @click="handleUpdateSelectedClick()">
            {{button_text}}
        </button>
    </div>

</template>

<script>
export default {
  name: 'SelectTask',
  props: {
    tasks: Array,
    value: Object,
    button_text: String
  },
  data: () => {
    return {
        selectedTask: null
    }
  },
  mounted() {
      if (this.tasks && this.tasks.length == 1) {
          this.selectedTask = this.tasks[0].value
      }
  },
  watch: {

  },
  computed: {

  },
  methods: {
      handleUpdateSelectedClick() {
          this.$emit("button-click", [this.selectedTask])
      }
  }
}
</script>
